exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-generated[data-v-cc39165e] hr{margin-top:15px!important;margin-bottom:15px!important;font-family:ABCFavorit!important}", ""]);

// exports
